import { http, lHttp } from '@utils/interceptor'
import { ActionContext, Module } from 'vuex'
import { getSelectedCityId } from '@utils/index'
import { localStore } from '@utils/storage';
import { isString } from 'lodash';
import { Toast } from 'vant'

const api = {
    searchResultApi: '//svsesapi.haiziwang.com/svses-api/api/queryAggregate.do',
    channelDataApi: '//soperationapi.haiziwang.com/soperation-api/citySite/queryChannel.do',
    // grayscale: '//cms.cekid.com/publish/999/h5-category-grayscale.json',
}


export enum RequestType {
    RequestAll = 1,
    RequestBuiness = 2,
    RequestProduct = 3,
    RequestMatron = 4,
    RequestConsultant = 5
}

export interface SearchTotalRequest {
    cityId?: string
    keyWords?: string
    tabs?: string
    longLatitude?: string   //经纬度，维度在前，经度在后
    position?: any
}
interface SearchResultRequest {
    type: RequestType     //搜索类型（1-全部 2-商家 3-商品）
    openOption?: boolean   //是否开启筛选功能
    keyWords?: string
    tabs?: string
    start: number
    limit?: number
    cityId?: string
    districtId?: string     //区ID
    longLatitude?: string   //经纬度，维度在前，经度在后
    query?: string   //产后康复专用
    distanceSort?: boolean
    distance?:string
    saleNumSort?: boolean
    storeFavPersonNumSort?: boolean
    level4CategoryId?: string | string[]
    position?: any
    starLevel?: string
    lightExperience?: string
    storeCode?: string
}

export interface BaseResponse<T> {
    code: string
    data: T
    msg: string
}

interface SearchResultResponse {
    businessInfo: SearchInfo
    cmmdtyInfo: SearchInfo
    maternityInfo: SearchInfo
    adviserInfo: SearchInfo
    categoryInfo: CategoryList[]
}



//商家info
interface SearchInfo {
    total: number
    list: any[]
    levelInfo: LevelBean[]
    experienceInfo: BrightBean[]
    storeInfo:StoreBean[]
}

export interface CategoryBean {
    title?: string
    id?: string
    categoryId?: string
}

export interface CategoryList {
    title: string
    id?: string
    list: CategoryBean[]
}

export interface LevelBean {
    starLevel?: string
    starLevelName?: string
    ID?: string
    NAME?: string
}

export interface BrightBean {
    lightExperience?: string
    lightExperienceName?: string
    ID?: string
    NAME?: string
}

export interface StoreBean {
    storeCode?: string
    storeName?: string
    ID?: string
    NAME?: string
}

export async function getSearchResult(req: SearchResultRequest): Promise<BaseResponse<SearchResultResponse>> {
    const cityId = getSelectedCityId()
    const { level4CategoryId, position } = req
    if (level4CategoryId && isString(level4CategoryId)) {
        req.level4CategoryId = level4CategoryId.split(',')
    } else {
        delete req.level4CategoryId
    }
    if (!req.query) delete req.query
    if (!req.districtId) delete req.districtId
    if (position && position.lng && position.lat) {
        req.longLatitude = `${position.lat},${position.lng}`
    }
    delete req.position
    return http.post(api.searchResultApi, { ...req, cityId })
}



export interface ChannelData{
    channelName: string
    categoryIds: string
    ads: any
    item: any[]
}

export async function getChannelData(channelId: string , cityId: string|number) : Promise<ChannelData>{
    const result = await lHttp.get(`${api.channelDataApi}`, { params: { cityId , channelId } })
    const { data, code, msg } = result
    if (+code === 1 && data ) {
        return data
    } else {
        Toast(msg)
        return Promise.reject(msg)
    }
}


